import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const slideUp = keyframes`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const revealAnimation = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const swapAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2) rotate(5deg);
    background-color: #aadeff;
  }
  100% {
    transform: scale(1);
  }
`;

export const opponentRevealAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 0, 0.7);
  }
  100% {
    box-shadow: 0 0 0 5px rgba(255, 255, 0, 0);
  }
`;

export const foundWordAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
    background-color: lightgreen;
  }
  100% {
    transform: scale(1);
  }
`;

export const flip = keyframes`
  0% {
    transform: perspective(400px) rotateY(90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateY(-20deg);
  }
  60% {
    transform: perspective(400px) rotateY(10deg);
  }
  80% {
    transform: perspective(400px) rotateY(-5deg);
  }
  100% {
    transform: perspective(400px) rotateY(0deg);
    opacity: 1;
  }
`;

export const wobble = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }
  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }
  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }
  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }
  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }
  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`;

export const shine = keyframes`
  0% {
    transform: translateX(-150%);
  }
  50% {
    transform: translateX(150%);
  }
  100% {
    transform: translateX(150%);
  }
`;

export const poof = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
    filter: blur(0px);
    background-color: #ff1744 !important;
    border-color: #e91e63 !important;
    box-shadow: 
      0 0 0 rgba(255, 23, 68, 0.9),
      3px 3px 6px rgba(255, 23, 68, 0.8),
      -3px -3px 6px rgba(233, 30, 99, 0.8);
  }
  15% {
    transform: scale(1.1) rotate(8deg);
    opacity: 0.95;
    filter: blur(0.5px);
    background-color: #ff9800 !important;
    border-color: #ff5722 !important;
    box-shadow: 
      0 0 8px rgba(255, 152, 0, 0.8),
      6px 2px 12px rgba(255, 87, 34, 0.7),
      -4px 6px 10px rgba(255, 193, 7, 0.7),
      2px -5px 8px rgba(255, 152, 0, 0.6);
  }
  30% {
    transform: scale(1.3) rotate(-5deg);
    opacity: 0.85;
    filter: blur(1px);
    background-color: #4caf50 !important;
    border-color: #8bc34a !important;
    box-shadow: 
      0 0 15px rgba(76, 175, 80, 0.7),
      10px -3px 18px rgba(139, 195, 74, 0.6),
      -8px 7px 15px rgba(102, 187, 106, 0.6),
      5px 8px 12px rgba(129, 199, 132, 0.5),
      -6px -5px 14px rgba(165, 214, 167, 0.5);
  }
  45% {
    transform: scale(1.5) rotate(12deg);
    opacity: 0.75;
    filter: blur(2px);
    background-color: #2196f3 !important;
    border-color: #03a9f4 !important;
    box-shadow: 
      0 0 22px rgba(33, 150, 243, 0.6),
      12px 4px 20px rgba(3, 169, 244, 0.5),
      -10px -6px 18px rgba(100, 181, 246, 0.5),
      8px -8px 16px rgba(144, 202, 249, 0.4),
      -5px 10px 14px rgba(187, 222, 251, 0.4),
      15px 2px 25px rgba(33, 150, 243, 0.3);
  }
  60% {
    transform: scale(1.7) rotate(-8deg);
    opacity: 0.6;
    filter: blur(3px);
    background-color: #9c27b0 !important;
    border-color: #e91e63 !important;
    box-shadow: 
      0 0 28px rgba(156, 39, 176, 0.5),
      15px -5px 25px rgba(233, 30, 99, 0.4),
      -12px 8px 22px rgba(186, 104, 200, 0.4),
      10px 10px 20px rgba(206, 147, 216, 0.3),
      -8px -10px 18px rgba(225, 190, 231, 0.3),
      18px 5px 30px rgba(156, 39, 176, 0.25),
      -15px 3px 28px rgba(233, 30, 99, 0.25);
  }
  75% {
    transform: scale(1.9) rotate(3deg);
    opacity: 0.4;
    filter: blur(4px);
    background-color: #ffeb3b !important;
    border-color: #ffc107 !important;
    box-shadow: 
      0 0 35px rgba(255, 235, 59, 0.4),
      20px 8px 32px rgba(255, 193, 7, 0.3),
      -18px -4px 30px rgba(255, 238, 88, 0.3),
      12px -12px 25px rgba(255, 241, 118, 0.25),
      -10px 15px 28px rgba(255, 245, 157, 0.25),
      25px -2px 40px rgba(255, 235, 59, 0.2),
      -20px 6px 35px rgba(255, 193, 7, 0.2),
      8px 18px 22px rgba(255, 249, 196, 0.15);
  }
  90% {
    transform: scale(2.1) rotate(-2deg);
    opacity: 0.2;
    filter: blur(5px);
    background-color: #00bcd4 !important;
    border-color: #26c6da !important;
    box-shadow: 
      0 0 42px rgba(0, 188, 212, 0.3),
      25px -10px 40px rgba(38, 198, 218, 0.2),
      -22px 12px 38px rgba(77, 208, 225, 0.2),
      15px 15px 35px rgba(128, 222, 234, 0.15),
      -15px -15px 32px rgba(178, 235, 242, 0.15),
      30px 5px 50px rgba(0, 188, 212, 0.1),
      -28px -8px 45px rgba(38, 198, 218, 0.1),
      20px -20px 30px rgba(179, 229, 252, 0.1),
      -12px 25px 35px rgba(224, 247, 250, 0.05);
  }
  100% {
    transform: scale(2.3) rotate(0deg);
    opacity: 0;
    filter: blur(6px);
    background-color: #f44336 !important;
    border-color: #ff5722 !important;
    box-shadow: 
      0 0 50px rgba(244, 67, 54, 0),
      30px 15px 50px rgba(255, 87, 34, 0),
      -25px -12px 45px rgba(239, 83, 80, 0),
      20px -18px 40px rgba(229, 115, 115, 0),
      -18px 20px 42px rgba(255, 138, 128, 0),
      35px -5px 60px rgba(244, 67, 54, 0),
      -30px 10px 55px rgba(255, 87, 34, 0),
      25px 25px 40px rgba(255, 205, 210, 0),
      -20px -25px 45px rgba(255, 235, 238, 0),
      40px 8px 70px rgba(244, 67, 54, 0);
  }
`;

export const letterFloat = keyframes`
  0%, 100% { 
    transform: translateY(0px) scale(1);
  }
  25% {
    transform: translateY(-3px) scale(2.05);
  }
  75% {
    transform: translateY(2px) scale(0.98);
  }
`;

export const letterSwapLeft = keyframes`
  0%, 90%, 100% { 
    transform: translateX(0) translateY(0) scale(1);
  }
  45% {
    transform: translateX(-1.2em) translateY(-0.2em) scale(1.1) rotate(-5deg);
  }
  55% {
    transform: translateX(-1.2em) translateY(-0.2em) scale(1.1) rotate(-5deg);
  }
`;

export const letterSwapRight = keyframes`
  0%, 90%, 100% { 
    transform: translateX(0) translateY(0) scale(1);
  }
  45% {
    transform: translateX(1.2em) translateY(-0.2em) scale(1.5) rotate(5deg);
  }
  55% {
    transform: translateX(1.2em) translateY(-0.2em) scale(1.5) rotate(5deg);
  }
`;

export const letterGlitch = keyframes`
  0%, 85%, 100% { 
    opacity: 1;
    transform: scale(1);
  }
  88% {
    opacity: 0.7;
    transform: scale(2.15) skew(2deg);
  }
  91% {
    opacity: 0.8;
    transform: scale(0.95) skew(-1deg);
  }
`;
